




"use strict";

export default class Overlay {

    constructor () {
        const closeBtn = document.createElement('button');
        closeBtn.classList.add('close-btn');

        document.querySelectorAll(`
            .overlay-modal h1:first-child,
            .overlay-modal h2:first-child,
            .overlay-modal h3:first-child,
            .overlay-modal h4:first-child,
            .overlay-modal h5:first-child,
            .overlay-modal h6:first-child
            `)
            .forEach(elem => elem.append(closeBtn.cloneNode()));


        document.querySelectorAll('[data-overlay]')
            .forEach(elem => elem.addEventListener('click', () => {
                const sName = elem.dataset.overlay;
                document.querySelector(`[data-name="${sName}"]`).classList.add('active');
            }));

        document.querySelectorAll('.overlay-modal-backdrop')
            .forEach(elem => elem.addEventListener('click', () => {
                const sName = elem.previousElementSibling.dataset.name;
                document.querySelector(`[data-name="${sName}"]`).classList.remove('active');
            }));

        document.querySelectorAll('.overlay-modal')
            .forEach(elem => {
                const sName = elem.dataset.name;
                if ( elem.querySelector('.close-btn') ) {
                    elem.querySelector('.close-btn').addEventListener('click', () => 
                        document.querySelector(`[data-name="${sName}"]`).classList.remove('active')
                    )
                }
            });
    }

}
